import { Link } from 'react-router-dom'

const CatalogTabNav = ({ pathname }) => {
  return <div style={{marginBottom: '15px', borderBottom: '1px rgba(0, 0, 0, 0.3) solid'}}>
    <Link to='/catalog/coffee' className={`${pathname.includes('coffee') ? 'w--current af-class-text-block-2 ' : ''}af-class-tab-p_catalog w-inline-block w-tab-link`}>Кофе</Link>
    <Link to='/catalog/tea' className={`${pathname.includes('tea') ? 'w--current af-class-text-block-2 ' : ''}af-class-tab-p_catalog w-inline-block w-tab-link`}>Чай</Link>
    <Link to='/catalog/accessories' className={`${pathname.includes('accessories') ? 'w--current af-class-text-block-2 ' : ''}af-class-tab-p_catalog w-inline-block w-tab-link`}>Аксессуары</Link>
    <Link to='/catalog/merch' className={`${pathname.includes('merch') ? 'w--current af-class-text-block-2 ' : ''}af-class-tab-p_catalog w-inline-block w-tab-link`}>Мерч</Link>
  </div>
}

export default CatalogTabNav